import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Renders markdown the way the app's MarkdownView does.
//
// react-markdown builds React elements rather than injecting HTML, so content
// authored by church staff cannot smuggle in markup. Raw HTML in the source is
// ignored by default — do not turn that on.
//
// Tailwind's preflight strips heading sizes and list markers, so every element
// we expect is styled explicitly here rather than relying on browser defaults.

export default function Markdown(props: { children: string }) {
  return <div className="flex flex-col gap-4 text-[17px] leading-normal text-gray-900">
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        p: ({ children }) => <p>{children}</p>,
        h1: ({ children }) => <h3 className="text-[22px] font-bold">{children}</h3>,
        h2: ({ children }) => <h4 className="text-[20px] font-semibold">{children}</h4>,
        h3: ({ children }) => <h5 className="text-[17px] font-semibold">{children}</h5>,
        ul: ({ children }) => <ul className="flex list-disc flex-col gap-2 pl-5">{children}</ul>,
        ol: ({ children }) => <ol className="flex list-decimal flex-col gap-2 pl-5">{children}</ol>,
        li: ({ children }) => <li>{children}</li>,
        strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
        em: ({ children }) => <em className="italic">{children}</em>,
        blockquote: ({ children }) => (
          <blockquote className="border-l-4 border-separator pl-4 text-gray-600">
            {children}
          </blockquote>
        ),
        code: ({ children }) => (
          <code className="rounded bg-gray-100 px-1 py-0.5 font-mono text-[15px]">
            {children}
          </code>
        ),
        hr: () => <hr className="border-separator" />,
        a: ({ href, children }) => (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-accent underline"
          >
            {children}
          </a>
        ),
      }}
    >
      {props.children}
    </ReactMarkdown>
  </div>
}
